import { Catalogs } from "../product";

const Modules = () => {
  return <Catalogs action="cutlist" />;
};

export default Modules;
